module.exports = __webpack_public_path__ + "static/media/linkedin-logo.b7b9d7b8.png";